import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudentRoutingModule } from './student-routing.module';
import { StudentUploadComponent } from './student-upload/student-upload.component';
import { StudentAdminStatusComponent } from './student-admin-status/student-admin-status.component';
import { StudentAdmissionDetailsComponent } from './student-admission-details/student-admission-details.component';
import { SummaryReportComponent } from './summary-report/summary-report.component';
import { IssueTCComponent } from './issue-tc/issue-tc.component';
import { StudentTCCountReportComponent } from './student-tccount-report/student-tccount-report.component';
import { StudentPromotionComponent } from './student-promotion/student-promotion.component';
import { StudentIDCardComponent } from './student-idcard/student-idcard.component';
import { SpecialAchievementComponent } from './special-achievement/special-achievement.component';
import { CounsellingRecordsComponent } from './counselling-records/counselling-records.component';
import { DisciplinaryRecordsComponent } from './disciplinary-records/disciplinary-records.component';
import { StudentCategoryReportComponent } from './student-category-report/student-category-report.component';
import { AdminModule } from '../admin/admin.module';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule, CollapseModule, TabsModule, TimepickerModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PrintStudentProfileComponent } from './print-student-profile/print-student-profile.component';
import { StudentListingReportComponent } from './student-listing-report/student-listing-report.component';
import { PrintTCComponent } from './print-tc/print-tc.component';
import { IssueTCListPrintComponent } from './issue-tclist-print/issue-tclist-print.component';
import { PrintIdCardComponent } from './print-id-card/print-id-card.component';
import { AdmissionReportComponent } from './admission-report/admission-report.component';
import { StudentDetailsComponent } from './student-details/student-details.component';
import { LeaveComponent } from './leave/leave.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { StudentfeebookuploadComponent } from './studentfeebookupload/studentfeebookupload.component';
@NgModule({
  declarations: [StudentUploadComponent, StudentAdminStatusComponent, StudentAdmissionDetailsComponent, SummaryReportComponent, IssueTCComponent, StudentTCCountReportComponent, StudentPromotionComponent, StudentIDCardComponent, SpecialAchievementComponent, CounsellingRecordsComponent, DisciplinaryRecordsComponent, StudentCategoryReportComponent, PrintStudentProfileComponent, StudentListingReportComponent, PrintTCComponent, IssueTCListPrintComponent, PrintIdCardComponent, AdmissionReportComponent, StudentDetailsComponent, LeaveComponent, AppointmentComponent, StudentfeebookuploadComponent],
  imports: [
    CommonModule,
    StudentRoutingModule,
    AdminModule ,    
    FormsModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    PopoverModule.forRoot(),
    TooltipModule.forRoot(),
    TimepickerModule.forRoot(),
   
  ]
})
export class StudentModule { }
